// the applied component should be button for this moment
$(document).on('turbolinks:load', function () {
  var consecutiveAbsentGenerateData = $('#consecutive-absent-index-generate-data');
  if (consecutiveAbsentGenerateData.length) {
    consecutiveAbsentGenerateData.on("click", function(){
      $('#overlay-on-submit-layer-js').removeClass("d-none");
    });
  }
});